"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initConfigsClient = void 0;
const config_result_1 = require("../generated/cdp/cof/config_result");
const evaluator_1 = require("../targeting_evaluation/evaluator");
const grpcWeb_1 = require("./grpcWeb");
// default settings
const DEFAULT_SETTINGS = {
    host: "https://aws.api.snapchat.com",
};
/**
 * Initializes COF configs client.
 * The function has to be called once on app startup.
 */
function initConfigsClient(initSettings) {
    const settings = Object.assign(Object.assign({}, DEFAULT_SETTINGS), initSettings);
    const client = Object.freeze({
        id: `${Math.random()}`,
        settings: settings,
        rpc: new grpcWeb_1.GrpcWebImpl(settings.host, {
            metadata: settings.metadata,
            transport: settings.transport,
            debug: settings.debug,
        }),
    });
    // Add default providers for browser height and width. Can be overridden by re-registering these properties.
    evaluator_1.registerPropertyValueProvider(client, config_result_1.ClientTargetingExpression_Property.WEB_SCREEN_HEIGHT, () => window.innerHeight);
    evaluator_1.registerPropertyValueProvider(client, config_result_1.ClientTargetingExpression_Property.WEB_SCREEN_WIDTH, () => window.innerWidth);
    return client;
}
exports.initConfigsClient = initConfigsClient;
//# sourceMappingURL=initConfigsClient.js.map